<div class="attachment-list" *ngFor="let attachment of attachments">
    <div class="attachment-ext">{{ attachment?.extension }}</div>
    <div class="attachment-name">{{ attachment?.name }}</div>
    <div class="attachment-download">
        <p-button (click)="download(attachment?.location)" icon="pi pi-download"></p-button>
    </div>
</div>
